
/*
  UXS — VOICE 001
  NATURAL SYNC V5

  UNIDOS X EL SONIDO

  - Apertura V4 original
  - Subtítulos letra por letra
  - Ritmo individual por palabra
  - Pausas naturales
  - Sincronización con audio.currentTime
  - Compatible con Alien Visualizer V4.1
  - VOICE 002 permanece intacta
*/

(function () {
  "use strict";

  function initializeUXSDialogue() {

    const main = document.getElementById("uxs-main");
    const circle = document.getElementById("uxs-visualizer");

    if (!main || !circle) return;

    if (main.dataset.uxsDialogueReady === "true") {
      return;
    }

    main.dataset.uxsDialogueReady = "true";

    // ========================================
    // CONFIGURACIÓN
    // ========================================

    const config = {
      audioURL:
        "https://cdn.shopify.com/s/files/1/0899/2040/5871/files/UXS_VOICE001_Apertura_V4_Ente_Suspendido.mp3?v=1792923626",

      // Esperar la introducción visual
      introDelay: 4300
    };

    // ========================================
    // TIEMPOS INDIVIDUALES POR PALABRA
    // ========================================
    // Alineación inicial estimada para V4.
    // Se puede afinar sin modificar el audio.

    const captions = [
      {
        start: 0.27,
        end: 3.10,

        words: [
          { text: "HOLA.", start: 0.27, end: 0.85 },
          { text: "¿HAY", start: 1.44, end: 1.82 },
          { text: "ALGUIEN", start: 1.82, end: 2.43 },
          { text: "AHÍ?", start: 2.43, end: 3.10 }
        ]
      },

      {
        start: 4.95,
        end: 7.82,

        words: [
          { text: "NO", start: 4.95, end: 5.18 },
          { text: "SÉ", start: 5.18, end: 5.52 },
          { text: "SI", start: 5.52, end: 5.76 },
          { text: "VINISTE", start: 5.76, end: 6.43 },
          { text: "POR", start: 6.43, end: 6.80 },
          { text: "TU", start: 6.81, end: 7.06 },
          { text: "CUENTA.", start: 7.06, end: 7.82 }
        ]
      },

      {
        start: 8.46,
        end: 12.35,

        words: [
          { text: "DE", start: 8.46, end: 8.68 },
          { text: "CUALQUIER", start: 8.68, end: 9.28 },
          { text: "FORMA,", start: 9.28, end: 10.12 },
          { text: "YA", start: 10.47, end: 10.79 },
          { text: "ESTÁS", start: 10.79, end: 11.30 },
          { text: "AQUÍ.", start: 11.30, end: 12.35 }
        ]
      }
    ];

    // ========================================
    // ESTILOS
    // ========================================

    if (!document.getElementById("uxs-dialogue-styles")) {

      const style = document.createElement("style");

      style.id = "uxs-dialogue-styles";

      style.textContent = `
        /* Ocultar texto antiguo de prueba */
        #uxs-main #uxs-message {
          display: none !important;
        }

        /* Subtítulo oficial */
        #uxs-voice001-subtitles {
          display: block;
          width: min(90vw, 650px);
          min-height: 65px;
          margin: 12px auto 8px;
          padding: 0 8px;

          color: #ffffff;
          font-family: monospace;
          font-size: clamp(13px, 2.5vw, 18px);
          font-weight: 400;
          letter-spacing: 1.5px;
          line-height: 1.8;
          text-align: center;

          overflow-wrap: break-word;
          white-space: pre-wrap;
        }

        /* Cursor */
        #uxs-voice001-subtitles .uxs-cursor {
          display: inline-block;
          width: 2px;
          height: 1em;
          margin-left: 3px;
          background: #ffffff;
          vertical-align: -0.15em;
          animation: uxs-cursor-blink 0.8s steps(1) infinite;
        }

        @keyframes uxs-cursor-blink {
          0%, 49% { opacity: 1; }
          50%, 100% { opacity: 0; }
        }

        /* Botón de respaldo para navegadores */
        #uxs-voice001-activate {
          display: none;
          margin: 12px auto;
          padding: 13px 30px;
          background: transparent;
          color: #ffffff;
          border: 1px solid #ffffff;
          font-family: monospace;
          font-size: 12px;
          letter-spacing: 2px;
          cursor: pointer;
        }

        #uxs-voice001-activate:hover {
          background: #ffffff;
          color: #050505;
        }
      `;

      document.head.appendChild(style);
    }

    // ========================================
    // OCULTAR TEXTO ANTERIOR
    // ========================================

    const oldMessage =
      main.querySelector("#uxs-message");

    if (oldMessage) {
      oldMessage.style.setProperty(
        "display",
        "none",
        "important"
      );

      oldMessage.setAttribute("aria-hidden", "true");
    }

    // ========================================
    // AUDIO VOICE 001
    // ========================================

    let audio =
      document.getElementById("uxs-voice001-player");

    if (!audio) {
      audio = document.createElement("audio");
      audio.id = "uxs-voice001-player";

      audio.crossOrigin = "anonymous";
      audio.preload = "auto";
      audio.playsInline = true;
      audio.style.display = "none";

      main.appendChild(audio);
    }

    audio.src = config.audioURL;

    // ========================================
    // SUBTÍTULOS
    // ========================================

    let subtitle =
      document.getElementById(
        "uxs-voice001-subtitles"
      );

    if (!subtitle) {
      subtitle = document.createElement("p");
      subtitle.id = "uxs-voice001-subtitles";

      subtitle.setAttribute("aria-live", "off");

      circle.insertAdjacentElement(
        "afterend",
        subtitle
      );
    }

    // ========================================
    // BOTÓN DE RESPALDO
    // ========================================

    let activate =
      document.getElementById(
        "uxs-voice001-activate"
      );

    if (!activate) {
      activate = document.createElement("button");
      activate.id = "uxs-voice001-activate";
      activate.type = "button";
      activate.textContent = "ACTIVAR SONIDO";

      subtitle.insertAdjacentElement(
        "afterend",
        activate
      );
    }

    // ========================================
    // ESTADO
    // ========================================

    let started = false;
    let finished = false;
    let starting = false;
    let animationFrame = null;

    let lastCaption = "";
    let lastCursorState = false;

    // ========================================
    // RENDERIZAR SUBTÍTULO
    // ========================================

    function renderSubtitle(text, cursorVisible) {

      if (
        text === lastCaption &&
        cursorVisible === lastCursorState
      ) {
        return;
      }

      lastCaption = text;
      lastCursorState = cursorVisible;

      subtitle.textContent = text;

      if (text && cursorVisible) {
        const cursor = document.createElement("span");

        cursor.className = "uxs-cursor";
        cursor.setAttribute("aria-hidden", "true");

        subtitle.appendChild(cursor);
      }
    }

    // ========================================
    // SUBTÍTULOS NATURALES
    // ========================================

    function updateSubtitles() {

      const time = audio.currentTime;

      let visibleText = "";
      let showCursor = false;

      for (const caption of captions) {

        if (
          time < caption.start ||
          time > caption.end
        ) {
          continue;
        }

        const completed = [];

        for (const word of caption.words) {

          if (time < word.start) {
            break;
          }

          if (time >= word.end) {
            completed.push(word.text);
            continue;
          }

          const duration =
            word.end - word.start;

          const progress = Math.max(
            0,
            Math.min(
              1,
              (time - word.start) / duration
            )
          );

          // Curva orgánica:
          // las primeras letras aparecen
          // un poco más rápido y las últimas
          // se sostienen ligeramente.

          const eased =
            1 - Math.pow(1 - progress, 2);

          const count = Math.max(
            1,
            Math.min(
              word.text.length,
              Math.ceil(
                eased * word.text.length
              )
            )
          );

          completed.push(
            word.text.slice(0, count)
          );

          showCursor = true;

          break;
        }

        visibleText = completed.join(" ");
        break;
      }

      renderSubtitle(
        visibleText,
        showCursor
      );
    }

    // ========================================
    // ANIMACIÓN
    // ========================================

    function stopCaptionAnimation() {
      if (animationFrame !== null) {
        cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
    }

    function captionLoop() {

      updateSubtitles();

      if (!audio.paused && !audio.ended) {
        animationFrame =
          requestAnimationFrame(captionLoop);
      } else {
        animationFrame = null;
      }
    }

    function startCaptionAnimation() {
      stopCaptionAnimation();
      animationFrame =
        requestAnimationFrame(captionLoop);
    }

    // ========================================
    // REPRODUCCIÓN DE APERTURA
    // ========================================

    async function playOpening() {

      if (finished || starting || started) {
        return;
      }

      starting = true;

      try {
        audio.currentTime = 0;

        await audio.play();

        started = true;
        activate.style.display = "none";

        startCaptionAnimation();

      } catch (error) {

        console.warn("UXS VOICE 001:", error);

        activate.textContent =
          error.name === "NotAllowedError"
            ? "ACTIVAR SONIDO"
            : "REINTENTAR AUDIO";

        activate.style.display = "block";

      } finally {
        starting = false;
      }
    }

    activate.addEventListener(
      "click",
      playOpening
    );

    // ========================================
    // EVENTOS DEL AUDIO
    // ========================================

    audio.addEventListener(
      "playing",
      startCaptionAnimation
    );

    audio.addEventListener(
      "pause",
      function () {
        stopCaptionAnimation();
        updateSubtitles();
      }
    );

    audio.addEventListener(
      "seeked",
      updateSubtitles
    );

    // ========================================
    // FIN DE LA APERTURA
    // ========================================

    audio.addEventListener(
      "ended",
      function () {

        if (finished) return;

        finished = true;
        started = false;

        stopCaptionAnimation();
        renderSubtitle("", false);

        activate.style.display = "none";

        main.dispatchEvent(
          new CustomEvent(
            "uxs:opening-ended",
            { bubbles: true }
          )
        );
      }
    );

    // ========================================
    // ERROR DE AUDIO
    // ========================================

    audio.addEventListener(
      "error",
      function () {
        console.error(
          "UXS: no se pudo cargar VOICE 001"
        );

        activate.textContent =
          "REINTENTAR AUDIO";

        activate.style.display = "block";
      }
    );

    // ========================================
    // INICIAR DESPUÉS DE LA INTRO
    // ========================================

    setTimeout(
      playOpening,
      config.introDelay
    );

    // ========================================
    // LIMPIEZA
    // ========================================

    window.addEventListener(
      "pagehide",
      function () {
        stopCaptionAnimation();
        audio.pause();
      },
      { once: true }
    );

    console.log(
      "UXS VOICE 001 — Natural Sync V5 Ready"
    );
  }

  // ========================================
  // INICIALIZACIÓN
  // ========================================

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeUXSDialogue
    );
  } else {
    initializeUXSDialogue();
  }

})();
